import { useEffect } from "react";

export default function useHeaderScroll() {
    useEffect(() => {
        let lastScrollTop = 0;
        let ticking = false;

        const header = document.querySelector("header");
        const overlay = document.querySelector(".overlay");
        const list = document.querySelectorAll(".list");

        const updateHeaderState = () => {
            const st = window.pageYOffset || document.documentElement.scrollTop;

            if (st > lastScrollTop && st > 40 && window.innerWidth > 0) {
                if (!overlay || !overlay.classList.contains("overlay--active")) {
                    header?.classList.add("hidden");
                }
            } else {
                if (st > 80) {
                    header?.classList.add("header-shrink");
                }
                header?.classList.remove("hidden");
            }

            if (st < 40) {
                header?.classList.remove("header-shrink");
            }

            lastScrollTop = st;
            ticking = false;
        };

        const handleScroll = () => {
            if (!ticking) {
                requestAnimationFrame(updateHeaderState);
                ticking = true;
            }
        };

        const handleActiveLink = (e) => {
            list.forEach((item) => item.classList.remove("active"));
            e.currentTarget.classList.add("active");
        };

        window.addEventListener("scroll", handleScroll, { passive: true });
        list.forEach((item) => item.addEventListener("click", handleActiveLink));

        return () => {
            window.removeEventListener("scroll", handleScroll);
            list.forEach((item) => item.removeEventListener("click", handleActiveLink));
        };
    }, []);
}